module.exports = __webpack_public_path__ + "static/media/flecha_down.dc6fcd0d.svg";